import { Injectable, inject } from '@angular/core';
import type { DriveErrorHandler } from '@mtm/drive/core';
import { OverlayService } from '../services/overlayService';

/** Surfaces Drive library errors through the app's existing toastr notifications. */
@Injectable({ providedIn: 'root' })
export class DriveErrorHandlerAdapter implements DriveErrorHandler {
  private readonly overlay = inject(OverlayService);

  showError(message: string): void {
    this.overlay.showError(message);
  }
}
